export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.207 2.207L5.414 4 8 6.585l3.793-3.792 1.414 1.414-1.319 1.317 7.498 7.497.075.084a1 1 0 01.21.736l-.451 3.964 3.488 3.488-1.415 1.414-3.486-3.487-3.966.452a1 1 0 01-.82-.287l-7.496-7.496-1.318 1.318-1.414-1.414 3.793-3.794L4 5.414 2.207 7.207.793 5.793l5-5 1.414 1.414zM6.965 10.5l4.06 4.06 2.268-2.267 1.414 1.414-2.268 2.268 1.656 1.655 3.172-.363.363-3.173-7.13-7.13L6.965 10.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};